// extracted by mini-css-extract-plugin
module.exports = {"buttons":"style_buttons__32TkI","button":"style_button__3ACDN","buttonDesktopHint":"style_buttonDesktopHint__7KcDG"};